<template>
  <div class="blog-feed-container">
    <div class="col-12 pl-4 pr-4 mb-3">
      <cool-select v-if="SHOW_SEARCH_BAR" class="custom-input" :placeholder="$t('message.Search topics you are interested in')" :items="[]" v-model="selectedBlogArticle" @search="searchFeedDebounce" @keyup="coolSelectOnKeyUp" :resetSearchOnBlur="false" ref="blogSearch">
        <template #no-data>
          {{ "" }}
        </template>
      </cool-select>
    </div>
    <!-- 100% changed to 100vh as temporary fix for browser app -->
    <div class="blog-articles" style="height: calc(100vh - 3em - 1.5rem);">
      <div class="row" style="height: 100%; overflow:auto;padding:0 1em 2em 1em;">
        <div class="blog-article col-12 col-sm-6" v-for="blogArticle in blogArticles" :key="blogArticle._id" @click="goToBlogArticle(blogArticle)">
          <dynamic-image-background class="card-body rounded" :fileId="blogArticle.titleImage"></dynamic-image-background>

          <div slot="footer" class="mt-2">
            <div style="flex: 3">
              <div>
                <h5 style="font-size: 1.1rem;font-weight: 600;">{{ blogArticle.title }}</h5>
              </div>
              <div>
                {{ blogArticle.description }}
              </div>
            </div>
            <div class="d-flex mt-3">
              <div class="pr-2">
                <div style="width: 2.5rem;aspect-ratio: 1/1;background: var(--gray);border-radius: 50%;display: grid;place-items: center;">
                  <i class="fa fa-user-edit" style="color:  var(--light);"></i>
                </div>
              </div>
              <div>
                <div>
                  <small>
                    <strong>
                      {{ blogArticle.author }}
                    </strong>
                  </small>
                </div>
                <div>
                  <small>
                    {{ _getFormattedDate(blogArticle.publishedOn, 'Do MMM YYYY') }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <infinite-loading spinner="waveDots" @infinite="getBlogArticles" :identifier="blogArticleSearchQuery">
          <span slot="no-more">{{ $t('message.No more articles') }}</span>
          <span slot="no-results">
            <p><i style="color: gray; padding-right: 0.5em;" class="fa fa-file-invoice"></i> {{ $t('message.No articles found') }} </p>
          </span>
        </infinite-loading>
      </div>

    </div>
  </div>
</template>

<script>
import { debounce } from "../../../services/debounce.service";

export default {
  name: "BlogFeed",

  created() {
    this.searchFeedDebounce = debounce(this.searchBlogArticles, 400);
  },

  data() {
    return {
      hasBlogs: false,
      selectedBlogArticle: null,
      blogArticles: [],
      blogArticlesPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 3,
      },
      blogArticleSearchQuery: "",
      category: "",
      fetching: false,
    };
  },

  async mounted() {
    this.category = this.$route.query.category || "";

    if (this.category) {
      this.setAppHeaderText(this.$t("message." + this.category + " Blog"));
    }

    this.getBlogFeedDataFromStore();
  },

  methods: {
    resetPagination() {
      this.blogArticlesPagination = {
        pageNumber: 1,
        totalPages: 0,
        pageSize: this.blogArticlesPagination.pageSize,
      };
    },

    setBlogFeedDataInStore() {
      this.$store.commit("setState", {
        stateName: "blogFeed",
        stateValue: {
          category: this.category,
          blogArticles: this.blogArticles,
          blogArticlesPagination: this.blogArticlesPagination,
        },
      });
    },
    getBlogFeedDataFromStore() {
      // get blog articles from store
      let feedStoreData = this.$store.state.blogFeed;
      if (feedStoreData) {
        if (feedStoreData.category == this.category) {
          this.blogArticles = this.$store.state.blogFeed.blogArticles;
          this.blogArticlesPagination =
            this.$store.state.blogFeed.blogArticlesPagination;
        }
      }
    },

    async getBlogArticles($state) {
      this.fetching = true;
      try {
        let response = await this.fetchBlogArticles();

        if (response.data && response.data.length) {
          this.hasBlogs = true;
          this.blogArticles.push(...response.data);
          this.blogArticlesPagination.totalPages = response.totalPages;
          this.blogArticlesPagination.pageNumber += 1;
          $state && $state.loaded();
        } else {
          $state && $state.complete();
        }
        if (!this.blogArticleSearchQuery) {
          this.setBlogFeedDataInStore();
        }
      } catch (error) {
        console.log(error);
      }
      this.fetching = false;
    },

    async fetchBlogArticles() {
      if (this.blogArticleSearchQuery) {
        if (this.category) {
          return await this.$store.dispatch("searchblogArticlesByCategory", {
            searchString: this.blogArticleSearchQuery,
            pageNumber: this.blogArticlesPagination.pageNumber,
            pageSize: this.blogArticlesPagination.pageSize,
            category: this.category,
          });
        } else {
          return await this.$store.dispatch("searchblogArticles", {
            searchString: this.blogArticleSearchQuery,
            pageNumber: this.blogArticlesPagination.pageNumber,
            pageSize: this.blogArticlesPagination.pageSize,
          });
        }
      } else {
        if (this.category) {
          return await this.$store.dispatch("getFeedArticlesByCategory", {
            pageNumber: this.blogArticlesPagination.pageNumber,
            pageSize: this.blogArticlesPagination.pageSize,
            category: this.category,
          });
        } else {
          return await this.$store.dispatch("getFeedArticles", {
            pageNumber: this.blogArticlesPagination.pageNumber,
            pageSize: this.blogArticlesPagination.pageSize,
          });
        }
      }
    },

    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.blogSearch.$el.querySelector("input").blur();
      }
    },

    async searchBlogArticles(searchString) {
      if (searchString) {
        this.blogArticleSearchQuery = searchString;
        this.blogArticles = [];
        this.resetPagination();
      } else {
        this.blogArticles = [];
        this.resetPagination();
        this.blogArticleSearchQuery = "";
      }
    },

    //Feed
    goToBlogArticle(blogArticle) {
      this.$store.commit("setState", {
        stateName: "blogArticle",
        stateValue: blogArticle,
      });
      this.$router.push("/blogarticle");
    },
  },

  computed: {
    SHOW_SEARCH_BAR() {
      if (this.hasBlogs) return true;

      if (this.hasBlogs) return true;

      return (
        this.blogArticles.length || this.blogArticleSearchQuery || this.fetching
      );
    },
  },
};
</script>

<style scoped>
/deep/.blog-articles .card-body {
  height: 12rem;
}

/deep/.blog-articles .card-body {
  background-size: cover;
  background-repeat: no-repeat;
}

/deep/.blog-articles .card:not(.add-meal) hr {
  display: none;
}
.blog-feed-container {
  height: 100%;
}

.blog-article {
  padding-bottom: 1rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #b8b5b5;
}

.custom-input.IZ-select {
  height: 3em;
  overflow: hidden;
}
</style>
